module.exports = __webpack_public_path__ + "img/មាន់ជល់វៀតណាម.a718232a.png";